import type { RouteName } from '/module/routing/types';

import type { Resource } from './data/types';

export type QueryMockConfig<Result = unknown> = {
  name: string;
  resources: Record<string, Resource<Result>> | (() => Promise<Record<string, Resource<Result>>>);
  description?: string;
  routeNames?: RouteName[];
  requestParams?: unknown;
};

export type MockSetting = {
  resourceName: string;
  delay?: number;
  error?: true | Error;
};

export type MockSettingName = `global_${string}` | `page_${string}_${string}`;

export const getMockSettingName = (mockConf: QueryMockConfig): MockSettingName => {
  return mockConf.routeNames ? `page_${mockConf.routeNames}_${mockConf.name}` : `global_${mockConf.name}`;
};
